import React from 'react';
import { Helmet } from 'react-helmet';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string[];
  canonical?: string;
}

export const SEOHead: React.FC<SEOHeadProps> = ({
  title = 'СметаFORTE - Программный модуль для сметного дела',
  description = 'СметаFORTE - профессиональный инструмент для составления смет, СВОР и управления строительными проектами',
  keywords = ['смета', 'строительство', 'СВОР', 'сметное дело', 'СметаFORTE', 'ГРАНД-Смета'],
  canonical,
}) => {
  const baseUrl = process.env.REACT_APP_API_URL || 'https://sd.smetaforte.ru';
  const fullTitle = title.includes('СметаFORTE') ? title : `${title} | СметаFORTE`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(', ')} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content="ООО ЦЭС" />
      
      {/* Open Graph для соцсетей */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical || baseUrl} />
      <meta property="og:image" content={`${baseUrl}/og-image.jpg`} />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Schema.org разметка */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          name: 'СметаFORTE',
          description: description,
          url: baseUrl,
          applicationCategory: 'BusinessApplication',
          offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'RUB'
          }
        })}
      </script>
    </Helmet>
  );
};